class OpalTheme {
    constructor() {
        this.SetUpBreacumb();
        jQuery(window).resize(() => {
            this.SetUpBreacumb();
        })
    }

    SetUpBreacumb() {

        let header = jQuery('body.opal-header-absolute #masthead .site-header'),
            breacumb = jQuery('.page-title-bar .wrap');
        if(header.length) {
            let Height = header.height();

            if(jQuery(window).width() > 992) {
                breacumb.css({
                    'min-height': 420 + Height,
                    'padding-top': Height
                })
            }else {
                breacumb.css({
                    'min-height': '',
                    'padding-top': ''
                })
            }
        }
    }
}

jQuery(document).ready(function ($) {
    new OpalTheme();
});